const LABELLING_TOOL_PATH = /^\/[^/]+\/tool(\/|$)/;

export const isLabellingToolPath = (pathname: string): boolean =>
  LABELLING_TOOL_PATH.test(pathname);
